const config = {
    api: process.env.REACT_APP_API_URL || "http://localhost:8080",
    oldApi: process.env.REACT_APP_OLD_API_URL || "https://api2.expliquemoipythagore.fr"
};

export default config;
